<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.xs="row"
	fxLayoutAlign.xs="start center" fxLayoutGap.xs="5px" class="stats">
	<ng-container *ngIf="stats?.type && stats?.data">
		<div class="graph-info" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px"
			[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
			<div class="feature-chart" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
				<ng-container *ngIf="stats?.type === 'lineChart' && stats?.data?.chartData && stats?.data?.chartOption">
					<app-line-chart [chartData]="stats?.data?.chartData" [chartOptions]="stats?.data?.chartOption">
					</app-line-chart>
				</ng-container>
			</div>
			<ng-container *ngIf="stats?.caption">
				<p class="read-info" [innerHtml]="stats?.caption | safeDom"></p>
			</ng-container>
		</div>

	</ng-container>
	<div class="stats-info" fxLayout="row wrap" fxLayoutGap="5px" fxLayoutGap.xs="0px" fxLayoutAlign="center center"
		*ngIf="![null, undefined].includes(stats?.messageCount) || ![null, undefined].includes(stats?.sharedCount) && ![null, undefined].includes(stats?.assignedCount)">
		<ng-container *ngIf="![null, undefined].includes(stats?.messageCount)">
			<div class="stats-item">
				<span class="stats-count">
					{{stats?.messageCount | abbreviateNumber}}
				</span>
				<mat-icon class="stats-icon" svgIcon="comments">
				</mat-icon>
			</div>
		</ng-container>
		<ng-container *ngIf="![null, undefined].includes(stats?.sharedCount)">
			<div class="stats-item">
				<span class="stats-count">
					{{stats?.sharedCount}}
				</span>
				<mat-icon class="stats-icon" svgIcon="forward_content">
				</mat-icon>
			</div>
		</ng-container>
		<ng-container *ngIf="![null, undefined].includes(stats?.assignedCount)">
			<div class="stats-item">
				<span class="stats-count">
					{{stats?.assignedCount}}
				</span>
				<mat-icon class="stats-icon" svgIcon="assignment"></mat-icon>
			</div>
		</ng-container>
	</div>
</div>
